import React, { useState, useEffect } from 'react';
import dailyReviewService from '../../services/dailyReviewService';
import './GoalTaskSelector.css';

const GoalTaskSelector = ({ projectId, onSelect, selectedTaskIds = [], tasks: providedTasks }) => {
    const [tasks, setTasks] = useState(providedTasks || []);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (providedTasks) {
            setTasks(providedTasks);
        } else if (projectId) {
            fetchTasks();
        }
    }, [projectId, providedTasks]);

    const fetchTasks = async () => {
        try {
            setLoading(true);
            const data = await dailyReviewService.getGoalsData(projectId);
            setTasks(data.tasks || []);
        } catch (error) {
            console.error('Error fetching tasks:', error);
        } finally {
            setLoading(false);
        }
    };

    const filteredTasks = tasks.filter(task => {
        if (selectedTaskIds.includes(task.id)) return false; // Don't show already selected
        const searchLower = searchTerm.toLowerCase();
        return (
            task.display_id?.toLowerCase().includes(searchLower) ||
            task.title?.toLowerCase().includes(searchLower)
        );
    });

    const handleSelect = (task) => {
        onSelect({
            taskId: task.id,
            taskTitle: task.title,
            displayId: task.display_id || `TASK-${task.id.substring(0, 8)}`,
            target: 'complete-today',
            status: 'pending',
            addedAt: new Date().toISOString()
        });
        setSearchTerm('');
        setIsOpen(false);
    };

    return (
        <div className="goal-task-selector">
            <div className="goal-selector-input-wrapper">
                <input
                    type="text"
                    className="goal-selector-input"
                    placeholder="Search tasks by ID or title..."
                    value={searchTerm}
                    onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setIsOpen(true);
                    }}
                    onFocus={() => setIsOpen(true)}
                />
                {isOpen && (
                    <div className="goal-selector-dropdown">
                        {loading ? (
                            <div className="goal-selector-loading">Loading tasks...</div>
                        ) : filteredTasks.length > 0 ? (
                            filteredTasks.map(task => (
                                <div
                                    key={task.id}
                                    className="goal-selector-item"
                                    onClick={() => handleSelect(task)}
                                >
                                    <div className="goal-selector-item-id">{task.display_id || `TASK-${task.id.substring(0, 8)}`}</div>
                                    <div className="goal-selector-item-title">{task.title}</div>
                                    <div className="goal-selector-item-status">{task.status}</div>
                                </div>
                            ))
                        ) : (
                            <div className="goal-selector-empty">No tasks found</div>
                        )}
                    </div>
                )}
            </div>
            {isOpen && (
                <div
                    className="goal-selector-overlay"
                    onClick={() => setIsOpen(false)}
                />
            )}
        </div>
    );
};

export default GoalTaskSelector;

